import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
} from "@mui/material";
import {
  fetchAcademicSessions,
  selectAllSessions,
  selectSessionsLoading,
  selectSessionsError,
} from "../../../Slices/sessionsSlice";
import AddHoliday from "./AddHoliday";
import HolidaysTable from "./HolidaysTable";
import { getHolidaysBySessionId } from "../../../ApiService/ApiService";
import { Add } from "@mui/icons-material";

function HolidaysSection() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAcademicSessions());
  }, [dispatch]);
  const sessions = useSelector(selectAllSessions);
  const sessionsLoading = useSelector(selectSessionsLoading);
  const sessionsError = useSelector(selectSessionsError);
  const [selectedSessionId, setSelectedSessionId] = useState("");
  const [showAddHoliday, setShowAddHoliday] = useState(false);
  const [holidays, setHolidays] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchHolidaysBySessionId = async (selectedSessionId) => {
    try {
      setLoading(true);
      const response = await getHolidaysBySessionId(selectedSessionId);
      // console.log("RES", response?.data);
      setHolidays(response?.data);
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sessions?.data?.length > 0) {
      setSelectedSessionId(sessions.data[0].id);
    }
  }, [sessions]);

  useEffect(() => {
    if (selectedSessionId) {
      fetchHolidaysBySessionId(selectedSessionId);
    }
  }, [selectedSessionId]);

  const handleSessionChange = async (event) => {
    setSelectedSessionId(event.target.value);
  };

  const renderMainContent = () => {
    if (showAddHoliday) {
      return (
        <AddHoliday
          setShowAddHoliday={setShowAddHoliday}
          setSelectedSessionId={setSelectedSessionId}
          fetchHolidaysBySessionId={fetchHolidaysBySessionId}
        />
      );
    } else {
      return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl size="small" sx={{ marginTop: 2, marginBottom: 2 }}>
            <InputLabel id="class">Sessions</InputLabel>
            <Select
              name="sessionId"
              label="Sessions"
              labelId="sessions"
              value={selectedSessionId}
              onChange={handleSessionChange}
              size="small"
              disabled={sessionsLoading || sessionsError}
              sx={{ width: "25%" }}
            >
              {sessions?.data?.length > 0 ? (
                sessions?.data?.map((currSession) => (
                  <MenuItem key={currSession.id} value={currSession.id}>
                    {currSession.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>Sessions unavailable</MenuItem>
              )}
            </Select>
          </FormControl>
          <HolidaysTable
            holidays={holidays}
            selectedSessionId={selectedSessionId}
            fetchHolidaysBySessionId={fetchHolidaysBySessionId}
          />
        </Box>
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddHoliday ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{ fontWeight: 600, fontSize: 22, color: "black" }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Holidays
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddHoliday(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add a Holiday
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default HolidaysSection;
